import { Message } from "features";
import styles from "./styles.module.scss";
import React from 'react';
import { PrecisionChatBotIcon } from "assets";
import TypeWriter from "components/typewriter";
import { FormattedMessage, hasMessageStructure } from "./formatted-message";

interface ChatBotProps {
  message: Message;
}

const ChatBot: React.FC<ChatBotProps> = ({ message }) => {
  const content = typeof message?.content === "string" ? message.content : "";
  const isComparisonIntro = content.includes("Great! Here's the comparison");

  // 🪄 Only display the short line if it's a comparison intro
  const displayText = isComparisonIntro
    ? "Great! Here's the comparison and ranking of the candidate CVs."
    : content;

  return (
    <div className={styles.chatBot}>
      <div className={styles.iconContainer}>
        <PrecisionChatBotIcon className={styles.icon} />
      </div>
      <div className={styles.content}>
        <div className={styles.message}>
          {typeof displayText === "string" && (
            // Structured messages (bulleted lists with section labels) are laid
            // out rather than typed: char-by-char animation of a list reflows on
            // every frame, and the design calls for real bullets and bold labels.
            hasMessageStructure(displayText) ? (
              <FormattedMessage text={displayText} />
            ) : message.isProcessed ? (
              <TypeWriter text={displayText} delay={0} speed={10} />
            ) : (
              displayText.split("\n").map((line, index) => (
                <p key={index}>
                  {message.isProcessed ? (
                    <TypeWriter text={line} delay={500} />
                  ) : (
                    line
                  )}
                </p>
              ))
            )
          )}
        </div>

        {message?.subText && (
          <p className={styles.subText}>
            {message.isProcessed ? (
              <TypeWriter text={message.subText} delay={0} />
            ) : (
              message.subText
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export { ChatBot };
